import { lib_names } from "../libs/lib.names";
import funcs_numbers from "./funcs.numbers";

//	E X P O R T   L I B

export default class funcs_text {

//#region 																							D E C L A R A T I O N S

	public static readonly text___empty_field: string = '×××××';

//#endregion

//#region 																							T E X T   R E T U R N   E M P T Y

	public static text___return_empty(
		___input: string | number | null | undefined,
		___string_to_append: string | null,
		___format_as: 'price' | 'mileage' | null = null
	) : string {

		let ___string___to_return: string = this.text___empty_field;

		if (___input !== null && ___input !== undefined && ___input.toString().length > 0)
		{
			let ___input___to_string___formatted: string = ___input.toString().trim();
			if (___input___to_string___formatted.length > 0)
			{
				switch (___format_as) {
					case 'mileage': ___input___to_string___formatted = funcs_numbers.format___mileage(___input) ; break;
					case 'price': ___input___to_string___formatted = funcs_numbers.format___price(___input, null) ; break;
				}
				const ___string_to_append___sanitized: string = (___string_to_append !== null) ? ___string_to_append : '';
				___string___to_return = ___input___to_string___formatted + '' + ___string_to_append___sanitized;
			}
		}

		return ___string___to_return as string;

	}

//#endregion

//#region 																							C H A R S   L I M I T

	public static chars___limit(
		___string: string,
		___limit: number
	) : string {
		const ___comparable___string: string = ___string ?? '';
		if (___comparable___string.length <= ___limit) { return ___comparable___string as string; }
		else { return ___comparable___string.substring(0, ___limit) + '...' as string; }
	}

//#endregion

//#region 																							T E X T   W R A P   R E A C T N O D E

	public static text_extendend___wrap___as___ReactNode(
		___input: string | React.ReactNode | any
	) : React.ReactNode {
		const ___wrapped: React.ReactNode = (typeof ___input === 'function') ? ___input() : (<>{ ___input }</>);
		return ___wrapped as any;
	}

//#endregion

//#region 																							T E X T   E N R I C H

	private static text_extended___enrich___is_url(
		___input_string: string
	) : boolean {
		const urlPattern = new RegExp(lib_names.regex.text_url, 'i');
		return !!urlPattern.test(___input_string);
	}

	public static text_extended___enrich(
		___input_text: string,
		___url_target: '_blank' | null = null
	) : React.ReactNode {

		const ___input_text___parsed: React.ReactNode = ___input_text.split('\n').map((___l, ___l_i, ___l_a) => {
		
			const ___w___array = ___l.split(' ').map((___w, ___w_i) => {
				let ___w___trimmed = ___w.trim();
				
				if (this.text_extended___enrich___is_url(___w___trimmed))
				{
					return <a href={ ___w___trimmed } target="_blank" rel="noopener noreferrer">{ ___w___trimmed }</a>;
				}

				if (___w___trimmed.startsWith('**') && ___w___trimmed.endsWith('**'))
				{
					___w___trimmed = ___w___trimmed.substring(2, ___w___trimmed.length - 2);
					return <strong>{ ___w___trimmed }</strong>;
				}
				else
				{
					const parts = ___w___trimmed.split('**');
					const processedParts = parts.map((part, index) => {
					if (index % 2 === 1) return <strong>{part}</strong>; return part; });
					return <>{processedParts}{ ___w_i < ___l.split(' ').length - 1 ? ' ' : ''}</>;
				}
			
				return <>{ ___w___trimmed }{ ___w_i < ___l.split(' ').length - 1 ? ' ' : ''}</>;
			
			});
		
			return <>{ ___w___array }{ ___l_i < ___l_a.length - 1 ? <br /> : null}</>;
		
		});
		
		return <>{ ___input_text___parsed }</>;
	}

//#endregion

//#region 																							S U B S T I T U T E

	static text_extended___enrich___substitute(
		___target: string,
		___mark: string,
		___element: string
	) : string {
		
		return ___target;
	
	
	//	const ___regex___search: RegExp = new RegExp(___mark.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
	//	return ___target.replace(___regex___search, ___element);
	}

//#endregion












}